export default "__VITE_ASSET__BG32rkE5__"